// #region Imports
// Librerías externas
import React, { useEffect, useState, useRef } from "react"
import { useDispatch } from "react-redux"
import { useFormik } from "formik"
import * as Yup from "yup"
import classnames from "classnames"
import { Link } from "react-router-dom"
import InputMask from "react-input-mask"
import { ToastContainer, toast } from "react-toastify"
import "react-toastify/dist/ReactToastify.css"
import Flatpickr from "react-flatpickr"
import "flatpickr/dist/themes/material_blue.css"
import { Spanish } from "flatpickr/dist/l10n/es.js"
import "react-datepicker/dist/react-datepicker.css"

// Componentes internos
import TableContainer from "../../components/Common/TableContainer"
import Breadcrumbs from "../../components/Common/Breadcrumb"
import Spinners from "components/Common/Spinner"
import AltaGenerales from "./AltaGenerales"
import AltaAcademico from "./AltaAcademico"
import Documentacion from "../../components/Common/Documentacion" //FormSectionAcademico
import FormSectionGenerales from "../../components/FormSections/FormSectionGenerales"
import FormSectionDirecciones from "../../components/FormSections/FormSectionDireccion"
import FormSectionAcademico from "../../components/FormSections/FormSectionAcademico"
import FormSectionCargos from "../../components/FormSections/FormSectionCargos"
import FormSectionDocumentos from "../../components/FormSections/FormSectionDocumentos"
import FormSectionFactura from "../../components/FormSections/FormSectionFactura"
import FormSectionResumen from "../../components/FormSections/FormSectionResumen"
import { AltaAlumnoSchema } from "../../utils/validationSchemas"

// Reactstrap
import {
  Badge,
  Card,
  CardBody,
  CardTitle,
  Col,
  Container,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
  Form,
  FormFeedback,
  FormGroup,
  Input,
  InputGroup,
  Label,
  NavItem,
  NavLink,
  Row,
  TabContent,
  TabPane,
  UncontrolledDropdown,
  UncontrolledAlert,
  UncontrolledTooltip,
} from "reactstrap"

// #region actions
import {
  unsetControlEscolarDescuentosInscripcion,
  unsetControlEscolarMensajeExito,
  unsetControlEscolarError,
  postControlEscolarCreateAlumno,
} from "../../store/actions"
// #endregion

// Selectors
import {
  useControlEscolarMensajeExito,
  useControlEscolarError,
} from "store/selectors"
import { hydrateRoot } from "react-dom/client"
// #endregion

const hoy = new Date()
const primerDiaMes = new Date(
  new Date().getFullYear(),
  new Date().getMonth(),
  1
)

const AltaAlumno = () => {
  //
  // #region react-redux
  const dispatch = useDispatch()
  // #endregion
  //#region Formik form
  // Definición de initialValues y validationSchema

  const initialValues = {
    id_Persona: -1,
    Apellido_Paterno: "",
    Apellido_Materno: "",
    Nombres: "",
    Curp: "",
    Email_Personal: "",
    Password: "",
    Telefono_Celular: "",
    Ciudad_Nacimiento: "",
    id_Estado_Nacimiento: 14,
    id_Pais_Nacimiento: 114,
    Fecha_Nacimiento: "",
    id_Estado_Civil: 1,
    Sexo: 1,
    //
    id_Direccion: -1,
    Calle: "",
    Numero_Exterior: "",
    Numero_Interior: "",
    Colonia: "",
    Municipio: "",
    Poblacion: "",
    id_Estado: 14,
    id_Pais: 114,
    Codigo_Postal: "",
    Apartado_Postal: "",
    Atencion: "",
    Coordenadas_GPS: "",
    Telefono_Fijo: "",
    Telefono_Fijo2: "",
    Telefono_Fijo3: "",
    Conmutador: "",
    Extension: "",
    Fax: "",
    // datos academicos
    id_Alumno: -1,
    id_Persona: -1,
    id_Campus: -1,
    id_Programa_Academico: -1,
    id_Plan_Estudio: -1,
    id_Nivel_Educativo: -1,
    id_Status: 1,
    id_Turno: -1,
    id_Turno_Extra: -1,
    id_Trayectoria: -1,
    id_Kardex: -1,
    Fecha_Inscripcion: primerDiaMes,
    En_Proceso_Revalidacion_Materias: "",
    Fecha_Inscripcion_SE: primerDiaMes,
    Fecha_Inicio_Clases: primerDiaMes,
    Rvoe: "",
    Grupo: "",
    Generacion: "",
    Matricula_SE: "",
    Matricula_Inea: "",
    Matricula_Interna: "",
    Es_Oficial: false,
    Curso_Propedeutico: false,
    Responsable: "",
    Reingreso: false,
    Fecha_Reingreso: "",
    //docs
    docs: [],
    //cargos
    id_Frecuencia: 1,
    cargarInscripcion: true,
    id_Descuento_Inscripcion: -1,
    Importe_Inscripcion: 0.0,
    Fecha_Inscripcion_Apartir: primerDiaMes,
    cargarColegiatura: true,
    id_Descuento_Colegiatura: -1,
    Importe_Colegiatura: 0.0,
    Fecha_Colegiatura_Apartir: primerDiaMes,
    // descuentos
    descuentos: [],
    // Resumen
    Nombre_Alumno: "",
    Nombre_Plan_Estudio: "",
    Nombre_Turno: "",
    Inscripcion: "",
    Colegiatura: "",
    Frecuencia: "Mensual",
  }

  const initialValuesLlenos = {
    id_Persona: -1,
    Apellido_Paterno: "SANCHEZ",
    Apellido_Materno: "FLORES",
    Nombres: "EDMUNDO",
    Curp: "SAFE131216HJCNLDA4",
    Email_Personal: "edmundo.sanchezf@gmail.com",
    Password: "1234123asd!",
    Telefono_Celular: "3314875965",
    Ciudad_Nacimiento: "PUERTO VALLARTA",
    id_Estado_Nacimiento: 14,
    id_Pais_Nacimiento: 114,
    Fecha_Nacimiento: "2011-12-16",
    id_Estado_Civil: 1,
    Sexo: 1,
    //
    id_Direccion: -1,
    Calle: "AV ENRIQUE DIAZ DE LEON",
    Numero_Exterior: "688",
    Numero_Interior: "18",
    Colonia: "VILLA DE LOS BELENES",
    Municipio: "ZAPOPAN",
    Poblacion: "ZAPOPAN",
    id_Estado: 14,
    id_Pais: 114,
    Codigo_Postal: "45157",
    Apartado_Postal: "APARTADO",
    Atencion: "ATN",
    Coordenadas_GPS: "GPS",
    Telefono_Fijo: "3333315840",
    Telefono_Fijo2: "3314147898",
    Telefono_Fijo3: "3339549438",
    Conmutador: "3333315870",
    Extension: "123",
    Fax: "3314587962",
    // datos academicos
    id_Alumno: -1,
    id_Persona: -1,
    id_Campus: -1,
    id_Programa_Academico: -1,
    id_Plan_Estudio: -1,
    id_Nivel_Educativo: -1,
    id_Status: 1,
    id_Turno: -1,
    id_Turno_Extra: -1,
    id_Trayectoria: -1,
    id_Kardex: -1,
    Fecha_Inscripcion: hoy,
    En_Proceso_Revalidacion_Materias: false,
    Fecha_Inscripcion_SE: hoy,
    Fecha_Inicio_Clases: hoy,
    Rvoe: "Rvoe",
    Grupo: "Grupo",
    Generacion: "Generacion",
    Matricula_SE: "MatriculaSE",
    Matricula_Inea: "MatriculaINEA",
    Matricula_Interna: "MatriculaInterna",
    Es_Oficial: false,
    Curso_Propedeutico: false,
    Responsable: "Responsable",
    Reingreso: false,
    Fecha_Reingreso: hoy,
    //docs
    docs: [
      {
        id_Documento: 1,
        description: "Acta de Nacimiento",
        Nombre_Documento: "Acta de Nacimiento",
        id_Relacion_Persona_Documento: -1,
        Original: 1,
        Copias: 1,
      },
      {
        id_Documento: 3,
        description: "Certificado de Secundaria",
        Nombre_Documento: "Certificado de Secundaria",
        id_Relacion_Persona_Documento: -1,
        Original: 1,
        Copias: 0,
      },
    ],
    //cargos
    id_Frecuencia: 1,
    cargarInscripcion: true,
    id_Descuento_Inscripcion: -1,
    Importe_Inscripcion: 0.0,
    Fecha_Inscripcion_Apartir: primerDiaMes,
    cargarColegiatura: true,
    id_Descuento_Colegiatura: -1,
    Importe_Colegiatura: 0.0,
    Fecha_Colegiatura_Apartir: primerDiaMes,
    descuentos: [],
    //Facturacion
    requiereFactura: false,
    id_Contribuyente: -1,
    soloColegiatura: false,
    usoCfdi: "",
    ccEmails: "",
    facturaObservaciones: "",
    // Resumen
    Nombre_Alumno: "EDMUNDO SANCHEZ MEDINA",
    Nombre_Plan_Estudio: "BACHILLERATO",
    Nombre_Turno: "",
    Inscripcion: "",
    Colegiatura: "",
    Frecuencia: "Mensual",
  }

  const onSubmit = values => {
    formik.values["descuentos"] = []
    if (
      formik.values.id_Descuento_Inscripcion > 0 ||
      formik.values.id_Descuento_Colegiatura > 0
    ) {
      if (formik.values.id_Descuento_Inscripcion > 0) {
        formik.values.descuentos.push({
          id_Descuento: formik.values.id_Descuento_Inscripcion,
        })
      }
      if (formik.values.id_Descuento_Colegiatura > 0) {
        formik.values.descuentos.push({
          id_Descuento: formik.values.id_Descuento_Colegiatura,
        })
      }
    }
    console.log("Form data", values)
    console.log("Inscripcion", values.Inscripcion)
    console.log("Importe_Inscripcion", values.Importe_Inscripcion)
    console.log("Colegiatura", values.Colegiatura)
    console.log("Importe_Colegiatura", values.Importe_Colegiatura)

    dispatch(
      postControlEscolarCreateAlumno({
        nombreSolicitud: "create",
        ...values,
      })
    )

    dispatch(unsetControlEscolarDescuentosInscripcion())
  }
  // Funciones para manejar cambios en mayúsculas y minúsculas
  const handleUpperCaseChange = event => {
    const { name, value } = event.target
    formik.setFieldValue(name, value.toUpperCase())
  }

  const handleLowerCaseChange = event => {
    const { name, value } = event.target
    formik.setFieldValue(name, value.toLowerCase())
  }

  const formik = useFormik({
    initialValues: initialValues,
    validationSchema: AltaAlumnoSchema,
    enableReinitialize: true,
    onSubmit: onSubmit,
  })
  // #endregion

  // #region Internal States

  // Estados para manejar tabs y pasos completados

  const [activeTab, setActiveTab] = useState(1)
  const [passedSteps, setPassedSteps] = useState([1])
  const [resetForm, setResetForm] = useState(0)
  const [resetContador, setResetContador] = useState(false)

  const [showPassword, setShowPassword] = useState(false)
  const [show, setShow] = useState(false)

  // #endregion

  // #region Const - Selectors
  // Estados para manejar tabs y pasos completados
  const mensajeExito = useControlEscolarMensajeExito()
  const mensajeError = useControlEscolarError()
  // #endregion

  // #region Functions

  const toggleTab = tab => {
    // Asegurarse de que el tab está dentro del rango válido
    if (tab < 1 || tab > 6) return

    // Si el tab es el siguiente al actual, permitir el cambio
    if (tab === activeTab + 1) {
      setActiveTab(tab)
      setPassedSteps(prev => [...prev, tab])
    }

    // Si el tab ya está en passedSteps, permitir volver a él
    if (passedSteps.includes(tab)) {
      setActiveTab(tab)
    }
  }

  // #endregion

  useEffect(() => {
    if (mensajeExito) {
      setResetForm(1)
      toast.success(mensajeExito, {
        autoClose: 2000,
      })
      dispatch(unsetControlEscolarMensajeExito())
      formik.resetForm()
      setResetForm(0)
    }
  }, [mensajeExito, dispatch, formik])

  useEffect(() => {
    if (mensajeError) {
      setResetContador(true)
      toast.error(mensajeError, {
        autoClose: 2000,
      })
      dispatch(unsetControlEscolarError())
      setResetContador(false)
    }
  }, [mensajeError, dispatch])

  return (
    <React.Fragment>
      <div className="page-content">
        <ToastContainer />
        <Container fluid>
          {/*  */}
          {/* Render Breadcrumb */}
          <Breadcrumbs
            title={"Control Escolar"}
            breadcrumbItem={"Alta Alumno"}
          />

          {/* Wizard */}
          <Row className="">
            <div className="wizard">
              <div className="steps">
                <ul>
                  <NavItem className={classnames({ current: activeTab === 1 })}>
                    <NavLink
                      className={classnames({ current: activeTab === 1 })}
                      onClick={() => {
                        toggleTab(1)
                      }}
                      disabled={!passedSteps.includes(1)}
                    >
                      <span className="number">1.</span> Generales
                    </NavLink>
                  </NavItem>
                  <NavItem className={classnames({ current: activeTab === 2 })}>
                    <NavLink
                      className={classnames({ active: activeTab === 2 })}
                      onClick={() => {
                        toggleTab(2)
                      }}
                      disabled={!passedSteps.includes(2)}
                    >
                      <span className="number">2.</span> Académicos
                    </NavLink>
                  </NavItem>
                  <NavItem className={classnames({ current: activeTab === 3 })}>
                    <NavLink
                      className={classnames({ active: activeTab === 3 })}
                      onClick={() => {
                        toggleTab(3)
                      }}
                      disabled={!passedSteps.includes(3)}
                    >
                      <span className="number">3.</span> Cargos
                    </NavLink>
                  </NavItem>
                  <NavItem className={classnames({ current: activeTab === 4 })}>
                    <NavLink
                      className={classnames({ active: activeTab === 4 })}
                      onClick={() => {
                        toggleTab(4)
                      }}
                      disabled={!passedSteps.includes(4)}
                    >
                      <span className="number">4.</span> Docs
                    </NavLink>
                  </NavItem>
                  <NavItem className={classnames({ current: activeTab === 5 })}>
                    <NavLink
                      className={classnames({ active: activeTab === 5 })}
                      onClick={() => {
                        toggleTab(5)
                      }}
                      disabled={!passedSteps.includes(5)}
                    >
                      <span className="number">5.</span> Factura
                    </NavLink>
                  </NavItem>
                  <NavItem className={classnames({ current: activeTab === 6 })}>
                    <NavLink
                      className={classnames({ active: activeTab === 6 })}
                      onClick={() => {
                        toggleTab(6)
                      }}
                      disabled={!passedSteps.includes(6)}
                    >
                      <span className="number">6.</span> Resumen
                    </NavLink>
                  </NavItem>
                </ul>
              </div>
            </div>
          </Row>

          <Form onSubmit={formik.handleSubmit}>
            <Row>
              <TabContent activeTab={activeTab} className="body mt-2">
                {/* FormSectionGenerales, FormSectionDireccion */}
                <TabPane tabId={1}>
                  <Card>
                    <CardBody>
                      <FormSectionGenerales
                        formik={formik}
                        handleUpperCaseChange={handleUpperCaseChange}
                        handleLowerCaseChange={handleLowerCaseChange}
                        isLoading={false} // Cambia según tu lógica de loading
                      />
                    </CardBody>
                  </Card>
                  <Card>
                    <CardBody>
                      <FormSectionDirecciones
                        formik={formik}
                        handleUpperCaseChange={handleUpperCaseChange}
                        handleLowerCaseChange={handleLowerCaseChange}
                        isLoading={false} // Cambia según tu lógica de loading
                      />
                    </CardBody>
                  </Card>
                </TabPane>
                {/* FormSectionAcademico */}
                <TabPane tabId={2}>
                  <Card>
                    <CardBody>
                      <FormSectionAcademico
                        formik={formik}
                        handleUpperCaseChange={handleUpperCaseChange}
                        handleLowerCaseChange={handleLowerCaseChange}
                        isLoading={false} // Cambia según tu lógica de loading
                      />
                    </CardBody>
                  </Card>
                </TabPane>{" "}
                {/* FormSectionCargos */}
                <TabPane tabId={3}>
                  {" "}
                  <FormSectionCargos
                    formik={formik}
                    handleUpperCaseChange={handleUpperCaseChange}
                    handleLowerCaseChange={handleLowerCaseChange}
                    isLoading={false} // Cambia según tu lógica de loading
                  />
                </TabPane>
                {/* FormSectionDocs */}
                <TabPane tabId={4}>
                  {" "}
                  <Card>
                    <CardBody>
                      <FormSectionDocumentos
                        formik={formik}
                        handleUpperCaseChange={handleUpperCaseChange}
                        handleLowerCaseChange={handleLowerCaseChange}
                        isLoading={false} // Cambia según tu lógica de loading
                      />
                    </CardBody>
                  </Card>
                </TabPane>{" "}
                {/* FormSectionFactura */}
                <TabPane tabId={5}>
                  {" "}
                  <Card>
                    <CardBody>
                      <FormSectionFactura
                        formik={formik}
                        handleUpperCaseChange={handleUpperCaseChange}
                        handleLowerCaseChange={handleLowerCaseChange}
                        resetForm={resetForm}
                      />
                    </CardBody>
                  </Card>
                </TabPane>
                {/* FormSectionResumen */}
                <TabPane tabId={6}>
                  <FormSectionResumen
                    formik={formik}
                    toggleTab={toggleTab}
                    resetForm={resetForm}
                    handleUpperCaseChange={handleUpperCaseChange}
                    handleLowerCaseChange={handleLowerCaseChange}
                  />
                </TabPane>
              </TabContent>
            </Row>

            {/* <Row>
              <div className="d-flex justify-content-end mt-2">
                <button
                  type="submit"
                  className="btn btn-primary w-md"
                  //disabled={!formik.isValid}
                  onClick={() => {
                    console.log(formik.values)
                  }}
                >
                  Registrar
                </button>
                <button
                  type="submit"
                  className="btn btn-primary w-md"
                  onClick={() => {
                    console.log(formik.errors)
                  }}
                >
                  check
                </button>
              </div>
            </Row> */}
          </Form>

          {/* Botones Anterior - Siguiente */}
          <Row className="mt-2">
            <div className="wizard clearfix">
              <div className="actions clearfix">
                <ul>
                  <li
                    className={
                      activeTab === 1 ? "previous disabled" : "previous"
                    }
                  >
                    <Link
                      to="#"
                      onClick={() => {
                        toggleTab(activeTab - 1)
                      }}
                    >
                      Anterior
                    </Link>
                  </li>
                  <li className={activeTab === 6 ? "next disabled" : "next"}>
                    <Link
                      to="#"
                      onClick={() => {
                        toggleTab(activeTab + 1)
                      }}
                    >
                      Siguiente
                    </Link>
                  </li>
                </ul>
              </div>
            </div>
          </Row>
        </Container>
      </div>
    </React.Fragment>
  )
}

export default AltaAlumno
